import React, { Fragment, useEffect } from 'react';
import { url } from '../../config';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useState } from 'react';
import { useLocation } from 'react-router';
import { getLastURL } from '../../helper';
import { useAlert } from 'react-alert';
import { subscription_expire } from '../../lang/alert_messages';

const ProtectedRoute = ({ component: Component, ...rest }) => {
    var { user } = useSelector(state => state.user)
    const location = useLocation();
    const pathname = getLastURL(location);
    const alert = useAlert();
    const history = useHistory()
    if (!user) {
        user = JSON.parse(sessionStorage.getItem('user'));
    }

    useEffect(() => {
        if (user?.is_business_step == 0 && (pathname != 'profile' && pathname != 'business-info')) {
            history.push(url + '/profile')
            alert.error('Please setup your buisness profile first.');

        }else if (user?.is_valid_plan == 0 && user?.role == 2 && user?.expiry_date && new Date(user.expiry_date) >= new Date()){
            alert.error(subscription_expire,{
                timeout:10000
            });
            setTimeout(() => {
                history.push(`${url}/plan-details`);
            }, 2000);
        }
    }, [pathname])

    return (
        <Fragment>
            <Route
                {...rest}
                render={props => {
                    if (localStorage.getItem('isAuthenticated') === null) {
                        return <Redirect to={url + "/login"} />
                    }
                    else {
                        return <Component {...props} />
                    }
                }}
            />
        </Fragment>
    )
}

export default ProtectedRoute
